"use client";
import React from 'react';

const MissionSection = () => {
    return (
        // Section sứ mệnh doanh nghiệp
        <section className="relative w-full lg:min-h-[400] xl:min-h-screen min-[1920px]:min-h-[850px] 2xl:min-[1920px]:min-h-[800px] overflow-hidden flex items-center justify-center p-4">
            {/* Khai báo font sử dụng trong section */}
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600&display=swap');
                
                .font-jakarta {
                    font-family: 'Plus Jakarta Sans', sans-serif;
                }
                .font-helvetica {
                    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                }
            `}</style>

            {/* Video nền */}
            <video
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src="/videos/VISION.mp4" type="video/mp4" />
            </video>

            {/* Khối nội dung trung tâm */}
            <div className="relative z-10 w-full max-w-5xl 2xl:max-w-7xl min-[1920px]:max-w-[100rem] flex flex-col md:block items-center justify-center md:aspect-[2/1] -translate-y-0 xl:-translate-y-10 2xl:-translate-y-12 min-[1920px]:-translate-y-16">

                {/* Vòng tròn trang trí */}
                <svg
                    className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                    w-[280px] h-[280px] 
                    md:w-[350px] md:h-[350px] 
                    xl:w-[500px] xl:h-[500px] 
                    2xl:w-[650px] 2xl:h-[650px] 
                    min-[1920px]:w-[800px] min-[1920px]:h-[800px] 
                    text-white/40 pointer-events-none transition-all duration-500"
                    viewBox="0 0 200 200"
                    fill="none"
                    strokeWidth="0.5"
                >
                    <defs>
                        <linearGradient id="arcFade" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
                            <stop offset="20%" stopColor="currentColor" stopOpacity="1" />
                            <stop offset="80%" stopColor="currentColor" stopOpacity="1" />
                            <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
                        </linearGradient>
                    </defs>

                    <path d="M 42 175 A 95 95 0 0 1 42 25" stroke="url(#arcFade)" />
                    <path d="M 158 25 A 95 95 0 0 1 158 175" stroke="url(#arcFade)" />
                </svg>

                {/* Tiêu đề trung tâm */}
                <div className="text-center relative mb-6 md:mb-0 md:absolute md:z-20 md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2">
                    <p className="text-white/80 text-[10px] md:text-[9px] xl:text-[10px] 2xl:text-xs min-[1920px]:text-sm tracking-[0.4em] uppercase mb-1 font-extralight" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                        ROVI HOLDINGS
                    </p>
                    <h2 className="font-helvetica text-white text-3xl md:text-2xl xl:text-4xl 2xl:text-5xl min-[1920px]:text-6xl font-thin tracking-wide" style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>Sứ mệnh</h2>
                </div>

                {/* Mục sứ mệnh bên trái */}
                <div className="relative mb-8 md:mb-0
                    md:absolute 
                    md:left-2 md:top-1/2
                    xl:left-0 xl:top-1/2 
                    md:-translate-y-1/2 
                    xl:-translate-x-3 
                    min-[1920px]:-translate-x-12
                    flex flex-col md:flex-row items-center 
                    gap-4 md:gap-3 xl:gap-5 2xl:gap-6 min-[1920px]:gap-8
                    w-full md:w-auto max-w-full md:max-w-[200px] xl:max-w-[320px] 2xl:max-w-[400px] min-[1920px]:max-w-[500px] 
                    text-center md:text-right transition-all duration-500"
                >
                    <div className="order-2 md:order-1 px-4 md:px-0">
                        <h3 className="font-jakarta text-white text-lg md:text-sm xl:text-xl 2xl:text-2xl min-[1920px]:text-3xl font-light mb-2 md:mb-1 xl:mb-2">
                            Phát triển bền vững
                        </h3>
                        <p className="font-helvetica text-white/90 text-sm md:text-[10px] xl:text-xs 2xl:text-sm min-[1920px]:text-lg font-normal leading-relaxed" style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                            Chất lượng dịch vụ tốt nhất, đảm bảo cho việc mở rộng và phát triển hệ sinh thái bền vững.
                        </p>
                    </div>
                    <div className="order-1 md:order-2 shrink-0 w-14 h-14 md:w-10 md:h-10 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20 min-[1920px]:w-24 min-[1920px]:h-24 rounded-full border border-white/40 flex items-center justify-center z-30 relative bg-green-800">
                        <img
                            src="/images/About/develop.png"
                            alt="Phát triển bền vững"
                            className="w-7 h-7 md:w-5 md:h-5 xl:w-10 xl:h-10 2xl:w-12 2xl:h-12 min-[1920px]:w-14 min-[1920px]:h-14 text-white relative z-30 object-contain"
                        />
                    </div>
                </div>

                {/* Mục sứ mệnh bên phải */}
                <div className="relative mb-8 md:mb-0
                    md:absolute 
                    md:right-2 md:top-1/2
                    xl:right-0 xl:top-1/2 
                    md:-translate-y-1/2 
                    xl:translate-x-3 
                    min-[1920px]:translate-x-12
                    flex flex-col md:flex-row items-center 
                    gap-4 md:gap-3 xl:gap-5 2xl:gap-6 min-[1920px]:gap-8
                    w-full md:w-auto max-w-full md:max-w-[200px] xl:max-w-[320px] 2xl:max-w-[400px] min-[1920px]:max-w-[500px] 
                    text-center md:text-left transition-all duration-500"
                >
                    <div className="shrink-0 w-14 h-14 md:w-10 md:h-10 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20 min-[1920px]:w-24 min-[1920px]:h-24 rounded-full border border-white/40 flex items-center justify-center z-30 relative bg-green-800">
                        <img
                            src="/images/About/right.png"
                            alt="Phát triển bền vững"
                            className="w-7 h-7 md:w-5 md:h-5 xl:w-10 xl:h-10 2xl:w-12 2xl:h-12 min-[1920px]:w-14 min-[1920px]:h-14 text-white relative z-30 object-contain"
                        />
                    </div>
                    <div className="px-4 md:px-0">
                        <h3 className="font-jakarta text-white text-lg md:text-sm xl:text-xl 2xl:text-2xl min-[1920px]:text-3xl font-light mb-2 md:mb-1 xl:mb-2">
                            Tạo ra sản phẩm khác biệt
                        </h3>
                        <p className="font-helvetica text-white/90 text-sm md:text-[10px] xl:text-xs 2xl:text-sm min-[1920px]:text-lg font-normal leading-relaxed" style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                            Mang lại cảm xúc thăng hoa và giá trị tốt đẹp cho khách hàng trong mỗi hành trình.
                        </p>
                    </div>
                </div>

                {/* Mục sứ mệnh phía dưới */}
                <div className="relative mb-0 md:mb-0
                    md:absolute 
                    md:bottom-[10%] xl:bottom-[2%] 
                    md:left-1/2 md:-translate-x-1/2 
                    flex flex-col items-center 
                    gap-4 md:gap-3 2xl:gap-5
                    w-full md:w-auto max-w-[300px] md:max-w-[350px] xl:max-w-[500px] 2xl:max-w-[650px] min-[1920px]:max-w-[800px]
                    text-center transition-all duration-500"
                >
                    <div className="shrink-0 w-14 h-14 md:w-10 md:h-10 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20 min-[1920px]:w-24 min-[1920px]:h-24 rounded-full border border-white/40 flex items-center justify-center z-30 relative bg-green-800">
                        <img
                            src="/images/About/bot.png"
                            alt="Phát triển bền vững"
                            className="w-7 h-7 md:w-5 md:h-5 xl:w-10 xl:h-10 2xl:w-12 2xl:h-12 min-[1920px]:w-14 min-[1920px]:h-14 text-white relative z-30 object-contain"
                        />
                    </div>
                    <h3 className="font-helvetica text-white text-base md:text-sm xl:text-xl 2xl:text-2xl min-[1920px]:text-3xl font-thin leading-tight px-2" style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                        Lợi ích cao nhất cho các nhà đầu tư, đối tác,
                        <br className="hidden md:block" />
                        <span className="md:inline block"> nhân viên, cộng đồng.</span>
                    </h3>
                </div>
            </div>
        </section>
    );
};

export default MissionSection;
